import { datadogRum } from '@datadog/browser-rum'

export type LogContext = Record<string, unknown>

export interface Logger {
  error(error: Error, context?: LogContext): void
  warn(message: string, context?: LogContext): void
  info(message: string, context?: LogContext): void
}

export interface CreateLoggerDependencies {
  environment: string
  consoleLogger: Logger
  datadogLogger: Logger
}

/* eslint-disable no-console */
const consoleLogger: Logger = {
  error: (error, context) => console.error(error, context),
  warn: (message, context) => console.warn(message, context),
  info: (message, context) => console.info(message, context)
}
/* eslint-enable no-console */

const datadogLogger: Logger = {
  error: (error, context) => {
    datadogRum.addError(error, context)
  },
  warn: (message, context) => {
    datadogRum.addAction(message, { ...context, level: 'warn' })
  },
  info: (message, context) => {
    datadogRum.addAction(message, { ...context, level: 'info' })
  }
}

export const createLogger = (dependencies: CreateLoggerDependencies): Logger =>
  dependencies.environment === 'development'
    ? dependencies.consoleLogger
    : dependencies.datadogLogger

export const logger = createLogger({
  environment: import.meta.env.MODE,
  consoleLogger,
  datadogLogger
})
